import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import React from 'react'

const SmartSortableItem = ({
  itemId, item, index, renderItem: RenderItem, disabled = false, dragHandle = false
}) => {
  const {
    setNodeRef,
    setActivatorNodeRef,
    attributes,
    listeners,
    transition,
    transform,
    isDragging,
    isSorting
  } = useSortable({ id: itemId, disabled })

  // Translate only. dnd-kit hands the dragged item a scale equal to the size of the droppable under
  // it over its own size (core's `adjustScale`), which is right for a DragOverlay but stretches or
  // squashes the item itself in a list whose rows differ in height: a 57px accordion header hovering
  // an expanded 600px block was drawn ten times taller. Rows of equal height get a scale of 1 anyway,
  // so dropping it changes nothing for them. `x` is zeroed too: the container's modifier already
  // locks the axis, but dnd-kit adds the ancestors' scroll delta after the modifiers run.
  const style = {
    transition,
    transform: CSS.Translate.toString(transform && { ...transform, x: 0 }),
    opacity: isDragging ? 0.5 : 1,
    cursor: dragHandle || disabled ? 'default' : isSorting ? 'grabbing' : 'grab'
  }

  // With a handle, the sensors' listeners and the ARIA attributes go to the one element the rendered
  // item nominates (`ref` is dnd-kit's activator node, which also keeps the keyboard sensor from
  // reacting to keys typed anywhere else inside the item). A press on a chart, a text field or a
  // table inside the item is then never the start of a drag. Without a handle the whole item stays
  // the grip, as every other list in Jupiter expects.
  const dragHandleProps = dragHandle ? { ref: setActivatorNodeRef, ...attributes, ...listeners } : undefined
  const gripProps = dragHandle ? {} : { ...attributes, ...listeners }

  return (
    <div
      ref={setNodeRef}
      {...gripProps}
      style={style}
    >
      <RenderItem item={item} index={index} dragHandleProps={dragHandleProps} />
    </div>
  )
}

export default SmartSortableItem
